/*********************** Custom JS for Boost AI Search & Discovery  ************************/
function checkOptionIsAvailable(option, data){
  let variants = data.variants;
  let is_available = false;
  for (let i = 0; i < variants.length; i++) {
    if(variants[i].original_merged_options.includes('color:'+option) && variants[i].available){
      return true;
    }
  }
  return is_available;
}

const boost_sd_customize = {
  update: (componentRegistry) => {

    // Update image Intrinsic size
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Modify Product Item',
      enabled: true,
      apply: () => ({
        afterRender(element) {

          try {
            // Start customization--------------------------------------------
            let productData = element.getParams().props.product;
            let itemEls = document.querySelectorAll('.boost-sd__product-item[data-product-id="'+ productData.id +'"]');

            itemEls.forEach(function(el){
              let itemEl = el;

              let newTitlePrice = document.createElement('div');
              let newVendorRating = document.createElement('div');
              let newColorTitle = document.createElement('div');
              let itemTitleEl = itemEl.querySelector('.boost-sd__product-title').cloneNode(true);
              let itemPriceEl = itemEl.querySelector('.boost-sd__product-price').cloneNode(true);
              let itemRatingEl = itemEl.querySelector('.boost-sd__integration-product-rating').cloneNode(true);
              let itemVendorEl = itemEl.querySelector('.boost-sd__product-vendor').cloneNode(true);

              if(newVendorRating && newTitlePrice.innerHTML == ''){
                newVendorRating.classList.add('boost-sd__product-vendor-and-rating');
                newVendorRating.appendChild(itemVendorEl);
                newVendorRating.appendChild(itemRatingEl);
                if(itemEl.querySelector('.boost-sd__product-vendor-and-rating') == null){
                  itemEl.querySelector('.boost-sd__product-info').insertAdjacentElement('afterbegin',newVendorRating);
                }
              }

              if(newTitlePrice && newTitlePrice.innerHTML == ''){
                newTitlePrice.classList.add('boost-sd__product-title-and-price');
                newTitlePrice.appendChild(itemTitleEl);
                newTitlePrice.appendChild(itemPriceEl);
                if(itemEl.querySelector('.boost-sd__product-title-and-price') == null){
                  itemEl.querySelector('.boost-sd__product-vendor-and-rating').insertAdjacentElement('afterend',newTitlePrice);
                }
              }

              if(newColorTitle && newColorTitle.innerHTML == ''){
                let defaultColor = productData.options_with_values.find(({name}) => 'color').values[0].title;
                newColorTitle.classList.add('boost-sd__product-color-title');
                newColorTitle.innerHTML = '<label>Color: </label><span class="amazing">'+ defaultColor +'</span><span class="temp">'+ defaultColor +'</span>';
                if(itemEl.querySelector('.boost-sd__product-swatch') && itemEl.querySelector('.boost-sd__product-color-title') == null){
                  itemEl.querySelector('.boost-sd__product-swatch').insertAdjacentElement('afterbegin',newColorTitle);
                  let itemSwatchOptions = itemEl.querySelectorAll('.boost-sd__product-swatch-option');
                  for (let i = 0; i < itemSwatchOptions.length; i++) {

                    itemSwatchOptions[i].addEventListener("mouseover", function(){
                      let hoverColorLabel = this.querySelector('label').textContent;
                      itemEl.querySelector('.boost-sd__product-color-title .temp').textContent = hoverColorLabel;
                      itemEl.querySelector('.boost-sd__product-color-title .amazing').style.display = "none";
                      itemEl.querySelector('.boost-sd__product-color-title .temp').style.display = "inline-block";
                    });

                    itemSwatchOptions[i].addEventListener("mouseleave", function(){
                      itemEl.querySelector('.boost-sd__product-color-title .amazing').style.display = "inline-block";
                      itemEl.querySelector('.boost-sd__product-color-title .temp').style.display = "none";
                    });

                    itemSwatchOptions[i].addEventListener("click", function(){
                      let hoverColorLabel = this.querySelector('label').textContent;
                      itemEl.querySelector('.boost-sd__product-color-title .amazing').textContent = hoverColorLabel;
                      itemEl.querySelector('.boost-sd__product-color-title .amazing').style.display = "inline-block";
                      itemEl.querySelector('.boost-sd__product-color-title .temp').style.display = "none";
                    });
                  }
                }
              }

              // Custom labels
              let productTags = productData.tags;
              let productCustomLabels = '';
              let productCustomLabelArr = [];
              for (let i = 0; i < productTags.length; i++) {
                if(productTags[i] == 'badge:Bestseller' && !productCustomLabelArr.includes('badge:Bestseller')){
                  productCustomLabelArr.push('badge:Bestseller');
                  productCustomLabels = `<div style="z-index: 2;" class="boost-sd-custom-badge absolute top-[6px] left-[6px] md:top-[10px] md:left-[10px]">
                    <div class="flex items-center font-secondary font-bold text-[12px] leading-[17px] text-white capitalize rounded-[5px] h-[23px] pl-[6px] badges-badge-bestseller">
                      <p class="pl-[4px] pr-[7px]">Bestseller</p>
                    </div>
                  </div>`;
                }
                if(productTags[i] == 'badge:New Arrival' && !productCustomLabelArr.includes('badge:New Arrival')){
                  productCustomLabelArr.push('badge:New Arrival');
                  productCustomLabels = `<div style="z-index: 2;" class="boost-sd-custom-badge  absolute top-[6px] left-[6px] md:top-[10px] md:left-[10px]">
                    <div class="flex items-center font-secondary font-bold text-[12px] leading-[17px] text-white capitalize rounded-[5px] h-[23px] pl-[6px] badges-badge-new-arrival">
                      <p class="pl-[4px] pr-[7px]"> New Arrival</p>
                    </div>
                  </div>`;
                }
              }
              if(productCustomLabelArr.length > 0 && itemEl.querySelector('.boost-sd-custom-badge') == null){
                itemEl.querySelector('.boost-sd__product-image').insertAdjacentHTML('beforeend',productCustomLabels);
              }
              // End custom labels
            });
            // End-------------------------------------------------------------
          } catch (e) {
            console.error(e);
          }

        },
      }),
    });
    /* end Custon Product Item */

    /* start Custom Swatches on Product List #218972 */
    componentRegistry.useComponentPlugin('ProductSwatch', {
      name: 'Modify Product Swatches',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            // Reupdate variant image by using metafield value
            let productData = null;
            let propOptions = null;
            let itemEls = null;

            if(element.getParams().props.isQuickView){
              productData = element.getParentElm().getParams().props.productData;
              propOptions = element.getParams().props.options;
              itemEls = document.querySelectorAll('.boost-sd__quick-view[product-id="'+ productData.id +'"]');
            }else{
              productData = element.getParentElm().getParams().props.data;
              propOptions = element.getParams().props.options;
              itemEls = document.querySelectorAll('.boost-sd__product-item[data-product-id="'+ productData.id +'"]');
            }

            let productMetafields = productData.metafields;
            let productMetaVariants = null;
            // let productImages = productData.images_info;
            // let productImageVariants = null;

            for (let i = 0; i < productMetafields.length; i++) {
              if(productMetafields[i].key == "swatch_image"){
                productMetaVariants = JSON.parse(productMetafields[i].value);
              }
            }

            for (let i = 0; i < propOptions.length; i++) {
              //let optionHex = productMetaVariants[propOptions[i].value]['hex'];
              let optionImageBg = null;

              if(productMetaVariants[propOptions[i].value]['image_url'] !== 'undefined'){
                optionImageBg = productMetaVariants[propOptions[i].value]['image_url'];
              }

              if(optionImageBg !== null){
                if(element.getParams().props.isQuickView){
                  itemEls.forEach(function(el){
                    let itemEl = el;
                    let itemQuickViewOptionElLabel = itemEl.querySelector('[value="'+ propOptions[i].value +'"] + label');
                    if(itemQuickViewOptionElLabel != null && itemQuickViewOptionElLabel != undefined){
                      itemQuickViewOptionElLabel.style.backgroundImage="url("+ optionImageBg +")";
                    }
                  });
                }else{
                  itemEls.forEach(function(el){
                    let itemEl = el;
                    //element.getParams().props.options[i].image = optionImageBg;
                    let itemOptionElLabel = itemEl.querySelector('[value="'+ propOptions[i].value +'"] + label');
                    if(itemOptionElLabel != null && itemOptionElLabel != undefined){
                      itemOptionElLabel.style.backgroundImage="url("+ optionImageBg +")";
                    }
                  });
                }
              }
              if(!checkOptionIsAvailable(propOptions[i].value, productData)){
                itemEls.forEach(function(el){
                  let itemEl = el;
                  let itemOptionEl = itemEl.querySelector('[value="'+ propOptions[i].value +'"]');
                  if (itemOptionEl != null && itemOptionEl != undefined) {
                    itemOptionEl.disabled = "disabled";
                  }
                });
              }
            }
          }catch (e) {
            console.error(e);
          }
        }
      })
    });
  },
};



window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  boost_sd_customize.update,
]);

if (window.boostSDAppConfig) {
  window.boostSDAppConfig.integration =  Object.assign({
    wishlists: 'king'
  }, window.boostSDAppConfig.integration || {});
}
